
export enum TipoModalidade {
  SKU = 'SKU',
  FAMILIA_PRODUTO = 'FAMILIA_PRODUTO'
}


